import StockDailyLedger from "@/pages/inventory/StockDailyLedger";
export default function FinishedDaily() {
  return <StockDailyLedger
    category="finished"
    title="Finished goods — daily ledger"
    subtitle="Opening · IN · OUT · Consumption · Closing. Locked daily by Warehouse Manager."
    ownerLabel="Warehouse Manager"
    testid="finished-daily-page"
  />;
}
